<template>
  <div class="tab-content product-tab-content">
    <div id="products-list" class="tab-pane" :class="activeTab('list')">
      <products-new-grouped-by-asin
        v-if="isListInitialized"
        :hasRefreshGroupTable="hasRefreshGroupTable"
        :currentTab="tab"
        :banner="banners.productListBanner || ''"
        @handleNotRefreshGroupTable="hasRefreshGroupTable = $event"
        @handleRefreshAmazonTable ="hasRefreshAmazonTable = $event"
      />
    </div>
    <div id="add-by-amazon" class="tab-pane" :class="activeTab('add-by-amazon')">
      <product-new-add
        v-if="isAmazonInitialized"
        :currentTab="tab"
        :banner="banners.productAddBanner || ''"
        :hasRefreshAmazonTable="hasRefreshAmazonTable"
        @handleNotRefreshAmazonTable="hasRefreshAmazonTable = $event"
        @handleRefreshGroupTable="hasRefreshGroupTable = $event"
      />
    </div>
    <div id="reports" class="tab-pane" :class="activeTab('reports')">
      <product-reports
        v-if="isReportsInitialized"
        :currentTab="tab"
      />
    </div>
  </div>
</template>
<script>
import ProductNewAdd from './ProductNewAdd.vue'
import ProductsNewGroupedByAsin from './ProductsNewGroupedByAsin.vue'
import ProductReports from './Reports.vue'

export default {
  components: {
    ProductNewAdd,
    ProductsNewGroupedByAsin,
    ProductReports
  },
  data () {
    return {
      hasRefreshGroupTable: false,
      hasRefreshAmazonTable: false,
      isListInitialized: false,
      isAmazonInitialized: false,
      isReportsInitialized: false
    }
  },
  props: {
    tab: {
      type: String,
      default: 'list'
    },
    banners: {
      type: Object,
      default () {
        return {
          productListBanner: '',
          productAddBanner: ''
        }
      }
    }
  },
  watch: {
    // Lazy mount: each tab initializes only on first visit to avoid simultaneous API calls on page load.
    tab: {
      immediate: true,
      handler (newTab) {
        if (newTab === 'list') this.isListInitialized = true
        else if (newTab === 'add-by-amazon') this.isAmazonInitialized = true
        else if (newTab === 'reports') this.isReportsInitialized = true
      }
    }
  },
  methods: {
    activeTab (tabName) {
      return this.tab === tabName ? 'active' : ''
    }
  }
}
</script>

<style scoped>
.product-tab-content {
  padding: 10px 20px 20px;
}
@media (max-width: 768px) {
  .product-tab-content {
    padding: 0;
  }
}
@media (max-width: 576px) {
  .product-tab-content {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/productsNew/TabContent.vue